export default function howToEarnReducer(state = {
  howToEarnArticles: [],
  fetching: false,
  fetched: false
}, action) {
  switch (action.type) {
    case 'GET_ARTICLES_HOW_TO_EARN_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_ARTICLES_HOW_TO_EARN_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        howToEarnArticles: action.payLoad
      };
    }
    case 'GET_ARTICLES_HOW_TO_EARN_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}
